(() => {
  document.querySelectorAll('[data-open-chapters]').forEach((link) => {
    const chapters = document.querySelector('.editorial-chapters');
    if (!chapters) return;
    link.addEventListener('click', (event) => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      chapters.open = true;
      chapters.querySelector('summary').focus();
    });
  });
  document.querySelectorAll('[data-atelier-video]').forEach((video) => {
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const play = () => { video.muted = true; video.play().catch(() => {}); };
    motion.addEventListener('change', () => {
      if (motion.matches) video.pause(); else play();
    });
    if (!motion.matches) play();
  });
  document.querySelectorAll('[data-editorial-menu-open]').forEach((button) => {
    if (button.dataset.ready) return;
    button.dataset.ready = 'true';
    const menu = document.getElementById(button.getAttribute('aria-controls'));
    if (!menu) return;
    let previousOverflow;
    button.addEventListener('click', () => {
      previousOverflow = document.body.style.overflow;
      menu.showModal();
      button.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    });
    menu.querySelector('[data-editorial-menu-close]').addEventListener('click', () => menu.close());
    menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => menu.close()));
    menu.addEventListener('close', () => {
      button.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = previousOverflow || '';
      button.focus();
    });
  });
  document.querySelectorAll('[data-standing-setting]').forEach((link) => {
    link.addEventListener('click', () => {
      const select = document.getElementById('standing-setting');
      if (select) select.value = link.dataset.standingSetting;
    });
  });
})();
